/**
 * @deprecated
 */
export default (seatTrade, message = '') => {
  return {
    message,
    data: {
      flightId: seatTrade.flightId,
    },
  }
}
